/* BLUECO mega menu: hovering or focusing a category tab shows its panel (snippets/bc-mega-menu.liquid). */
(function () {
  function activate(tab) {
    var mega = tab.closest('[data-bc-mega]');
    if (!mega) return;
    var i = tab.getAttribute('data-bc-tab');
    mega.querySelectorAll('[data-bc-tab]').forEach(function (t) { t.classList.toggle('is-active', t === tab); });
    mega.querySelectorAll('[data-bc-panel]').forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-bc-panel') === i); });
  }
  document.addEventListener('mouseover', function (e) {
    var tab = e.target.closest && e.target.closest('[data-bc-tab]');
    if (tab) activate(tab);
  });
  document.addEventListener('focusin', function (e) {
    var tab = e.target.closest && e.target.closest('[data-bc-tab]');
    if (tab) activate(tab);
  });
})();
